import React, { type FunctionComponent, useState, useMemo, useEffect } from 'react';
import { ContentContainer } from '../../components/ContentContainer';
import { type Column } from 'react-table';
import { TableContainer } from '../../components/table/TableContainer';
import { Request as apiRequest, openInNewTab } from '../../helper';

interface ExperimentalItem {
    email: string;
}

interface ExperimentalResponse {
    result: ExperimentalItem[];
}

export const ExperimentalList: FunctionComponent = () => {
    const [issues, setIssues] = useState<ExperimentalItem[]>();

    useEffect(() => {
        setIssues(undefined);
        async function getIssues(): Promise<void> {
            const response = await apiRequest.get<ExperimentalResponse>({ path: '/support/experimental/user' });
            setIssues(response.data.result);
        }
        getIssues();
    }, []);

    const tableData = useMemo(() => issues, [issues]);
    const columns: Array<Column<ExperimentalItem>> = useMemo(
        () => [
            {
                Header: 'email',
                accessor: 'email',
            },
        ],
        [issues],
    );

    return (
        <ContentContainer headline="Experimental User List" showSpinner={!issues}>
            {tableData && (
                <TableContainer
                    columns={columns}
                    data={tableData}
                    search={{
                        placeholder: 'Search for a experimental user',
                    }}
                    initialState={{
                        sortBy: [{ id: 'email', desc: false }],
                    }}
                    defaultPageSize={20}
                    rowClick={(item) => {
                        openInNewTab(`https://lic.outbankapp.com/manager?email=${encodeURIComponent(item.email)}`);
                    }}
                />
            )}
        </ContentContainer>
    );
};
